import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white-950 text-stone-100">
      <Header />
      <main className="flex-1 flex-col flex">{children}</main>
      <Footer />
    </div>
  );
}
